import ConnexionModal from './ConnexionModal.view';

export default ConnexionModal;
